var map = {
	"./dev.env.js": "dhIU",
	"./prod.env.js": "rBKV",
	"./test.env.js": "WXia"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9t4T";


//////////////////
// WEBPACK FOOTER
// ./config ^\.\/.*\.env\.js$
// module id = 9t4T
// module chunks = 1